(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theinmag-home-flipthrough"] && !Shopify.designMode) return;
  try {
    
  /* In-place flick-through. One spread at a time, wraps around, moves
     only when the visitor moves it (arrows, swipe or drag, arrow keys).
     Off-screen spreads stay display:none so their lazy images do not
     download until warmed; neighbours are warmed once the section is
     on screen so a flick paints instantly. */
  (function () {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-hf-root]').forEach(function (root) {
      var stage = root.querySelector('[data-hf-stage]');
      var pages = Array.prototype.slice.call(root.querySelectorAll('[data-hf-page]'));
      var prev = root.querySelector('[data-hf-prev]');
      var next = root.querySelector('[data-hf-next]');
      var current = root.querySelector('[data-hf-current]');
      var leafStatic = root.querySelector('[data-hf-static]');
      var leafTurn = root.querySelector('[data-hf-turn]');
      var leafStaticImg = leafStatic && leafStatic.querySelector('img');
      var leafTurnImg = leafTurn && leafTurn.querySelector('img');
      var n = pages.length;
      if (!stage || n < 1) return;

      var i = 0;
      var busy = false;
      var drag = null;

      function warm(idx) {
        var p = pages[(idx + n) % n];
        if (!p || p.dataset.hfWarm) return;
        p.dataset.hfWarm = '1';
        var im = new Image();
        var ss = p.getAttribute('srcset');
        if (ss) { im.sizes = p.getAttribute('sizes') || ''; im.srcset = ss; }
        im.src = p.getAttribute('src');
      }

      function update() {
        if (current) current.textContent = String(i + 1);
      }

      function finishFlip(out) {
        out.classList.add('is-parked');
        if (leafStatic) {
          leafStatic.style.transition = 'none';
          leafStatic.style.opacity = '0';
        }
        if (leafTurn) {
          leafTurn.style.transition = 'none';
          leafTurn.style.opacity = '0';
          leafTurn.style.transform = 'rotateY(0deg)';
          leafTurn.style.boxShadow = '';
        }
        // Drop the overlay pictures so a later flick can never flash the
        // spread from the PREVIOUS turn while its new halves are decoding.
        if (leafStaticImg) leafStaticImg.removeAttribute('src');
        if (leafTurnImg) leafTurnImg.removeAttribute('src');
        busy = false;
      }

      function go(dir) {
        if (busy) return;
        var from = i;
        var to = (i + dir + n) % n;
        if (to === from) return;
        var out = pages[from];
        var inn = pages[to];
        busy = true;

        var canFlip = leafStatic && leafTurn && leafStaticImg && leafTurnImg && !reduced;
        if (!canFlip) {
          inn.classList.remove('is-parked');
          inn.classList.add('is-active');
          out.classList.remove('is-active');
          out.classList.add('is-parked');
          i = to; update(); warm(to + 1); warm(to - 1);
          busy = false;
          return;
        }

        // Load both halves of the OUTGOING spread into the overlay <img>s but
        // keep the overlays HIDDEN until they have decoded. An <img> keeps
        // painting its old picture until a new src is ready, so showing the
        // overlays first flashed the previous turn's spread for a few frames
        // (the "flickers back a page" glitch). Use the exact candidate the
        // base is already displaying so the decode is a cache hit.
        var src = out.currentSrc || out.getAttribute('src');
        leafStatic.style.transition = 'none';
        leafTurn.style.transition = 'none';
        leafStatic.style.opacity = '0';
        leafTurn.style.opacity = '0';
        leafTurn.style.transform = 'rotateY(0deg)';
        leafTurn.style.boxShadow = '';
        if (dir > 0) {
          // Next: the RIGHT page lifts; the LEFT half is held static.
          leafStatic.style.left = '0';
          leafStaticImg.style.left = '0';
          leafTurn.style.left = '50%';
          leafTurnImg.style.left = '-100%';
          leafTurn.style.transformOrigin = 'left center';
        } else {
          // Prev: the LEFT page lifts; the RIGHT half is held static.
          leafStatic.style.left = '50%';
          leafStaticImg.style.left = '-100%';
          leafTurn.style.left = '0';
          leafTurnImg.style.left = '0';
          leafTurn.style.transformOrigin = 'right center';
        }
        leafStaticImg.src = src;
        leafTurnImg.src = src;

        var revealed = false;
        var commit = function () {
          i = to;
          update();
          warm(to + 1);
          warm(to - 1);
        };
        // Turn path: overlays are decoded. Show them (still no transition),
        // swap the base beneath in the same frame, then start the turn.
        var reveal = function () {
          if (revealed) return;
          revealed = true;
          leafStatic.style.opacity = '1';
          leafTurn.style.opacity = '1';
          void leafTurn.offsetWidth;
          inn.classList.remove('is-parked');
          inn.classList.add('is-active');
          out.classList.remove('is-active');
          void leafTurn.offsetWidth;

          leafStatic.style.transition = '';
          leafTurn.style.transition = '';
          leafTurn.style.transform = dir > 0 ? 'rotateY(-88deg)' : 'rotateY(88deg)';
          leafTurn.style.opacity = '0';
          leafStatic.style.opacity = '0';
          leafTurn.style.boxShadow = dir > 0
            ? '-20px 0 30px rgba(42, 31, 61, 0.20)'
            : '20px 0 30px rgba(42, 31, 61, 0.20)';
          commit();
          window.setTimeout(function () { finishFlip(out); }, 640);
        };
        // Safety path: decode did not resolve in time (hidden tab, slow
        // network). Swap cleanly with NO overlays rather than risk a flash.
        var plainSwap = function () {
          if (revealed) return;
          revealed = true;
          inn.classList.remove('is-parked');
          inn.classList.add('is-active');
          out.classList.remove('is-active');
          commit();
          finishFlip(out);
        };
        var afterDecode = function () {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(reveal);
          });
        };
        var decodes = [];
        try { if (leafStaticImg.decode) { decodes.push(leafStaticImg.decode()); } } catch (e) {}
        try { if (leafTurnImg.decode) { decodes.push(leafTurnImg.decode()); } } catch (e) {}
        if (decodes.length) {
          Promise.all(decodes.map(function (p) { return (p && p.catch) ? p.catch(function () {}) : p; })).then(afterDecode);
        } else {
          window.setTimeout(afterDecode, 60);
        }
        window.setTimeout(plainSwap, 700);
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });

      /* Swipe / drag. touch-action: pan-y on the stage leaves vertical
         scrolling to the browser; we only claim the gesture once it is
         clearly horizontal. The active spread follows the finger a
         little for a tactile flick, then commits or snaps back. */
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), dx: 0, locked: false };
      });
      stage.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        var dy = e.clientY - drag.y;
        if (!drag.locked) {
          if (Math.abs(dx) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
          drag.locked = true;
          try { stage.setPointerCapture(e.pointerId); } catch (err) { /* older engines */ }
          stage.classList.add('is-dragging');
        }
        drag.dx = dx;
      });
      function release(e) {
        if (!drag || (e && e.pointerId !== drag.id)) return;
        var dx = drag.dx;
        var quick = Math.abs(dx) > 24 && (Date.now() - drag.t) < 260;
        stage.classList.remove('is-dragging');
        if (drag.locked && (Math.abs(dx) > 44 || quick)) {
          go(dx < 0 ? 1 : -1);
        }
        drag = null;
      }
      stage.addEventListener('pointerup', release);
      stage.addEventListener('pointercancel', release);
      stage.addEventListener('lostpointercapture', release);

      /* Warm the two neighbours once the section is near the viewport. */
      if (n > 1) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              warm(1); warm(n - 1);
              io.disconnect();
            });
          }, { rootMargin: '200px 0px' });
          io.observe(root);
        } else {
          warm(1); warm(n - 1);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theinmag-issue-strip"] && !Shopify.designMode) return;
  try {
    
  /* Listen for the single-mags-hero Format toggle and mirror the active
     format onto each issue-strip section so the picker tiles can swap
     between print covers and iPad-mockup digital covers via CSS.

     The hero's toggle markup is:
       <div data-variant-group>
         <button data-variant-format="Print" aria-pressed="true">...</button>
         <button data-variant-format="Digital" aria-pressed="false">...</button>
       </div>

     We don't own that markup so we passively listen for clicks on it. If
     the hero isn't on the page (e.g. /products/membership which has its
     own picker but no single-mags-hero), there's nothing to listen for
     and the section stays in default "Print" mode. */
  (function () {
    function syncStrips(format) {
      var strips = document.querySelectorAll('[data-theinmag-issue-strip]');
      for (var i = 0; i < strips.length; i++) {
        strips[i].setAttribute('data-active-format', format);
      }
    }

    function init() {
      /* SHELF BUDDY: fresh character every page load (Ryan, 2026-08-12).
         Server renders candidate 1; JS re-rolls from the emitted pool so
         even a cached page shows a different kid per visit. */
      var buddyHosts = document.querySelectorAll('[data-buddy-pool]');
      for (var b = 0; b < buddyHosts.length; b++) {
        var pool = (buddyHosts[b].getAttribute('data-buddy-pool') || '').split('|');
        var img = buddyHosts[b].querySelector('[data-buddy-img]');
        if (img && pool.length > 1) {
          img.src = pool[Math.floor(Math.random() * pool.length)];
        }
      }

      /* MEMBERSHIP PAGE SYNC (2026-08-12). The membership page has no
         single-mags-hero, so the strip used to follow the sticky
         sessionStorage format from a PREVIOUS page while the membership
         form sat on Print - Ryan caught the mismatch (Print selected,
         digital covers showing). Here the form is the source of truth:
         sync the strip AND the sitewide sticky format to whatever pill
         is pressed, at load and on every toggle. */
      var memberPills = document.querySelector('[data-theinmag-membership-form] [data-option-name="format"]');
      if (memberPills) {
        var syncFromMembership = function () {
          var pressed = memberPills.querySelector('[data-value][aria-pressed="true"]');
          var fmt = pressed && pressed.dataset.value === 'Digital' ? 'Digital' : 'Print';
          syncStrips(fmt);
          document.documentElement.setAttribute('data-theinmag-format', fmt);
          try { sessionStorage.setItem('theinmag.activeFormat', fmt); } catch (e) { /* private mode */ }
        };
        syncFromMembership();
        memberPills.addEventListener('click', function (event) {
          if (!event.target.closest('[data-value]')) return;
          /* Let the form's own JS flip aria-pressed first. */
          setTimeout(syncFromMembership, 0);
        });
        /* Belt-and-braces: the form JS can flip format without a click
           (e.g. forcing Digital when Print sells out). */
        var pillObserver = new MutationObserver(syncFromMembership);
        var pills = memberPills.querySelectorAll('[data-value]');
        for (var k = 0; k < pills.length; k++) {
          pillObserver.observe(pills[k], { attributes: true, attributeFilter: ['aria-pressed'] });
        }
      }

      var group = document.querySelector('[data-variant-group]');
      if (!group) return;

      // Pick up any format that's already pressed at load (e.g. Print sold out
      // → JS bumps to Digital before our listener fires).
      var pressed = group.querySelector('[data-variant-format][aria-pressed="true"]');
      if (pressed && pressed.dataset.variantFormat) {
        syncStrips(pressed.dataset.variantFormat);
      }

      group.addEventListener('click', function (event) {
        var tile = event.target.closest('[data-variant-format]');
        if (!tile || !tile.dataset.variantFormat) return;
        syncStrips(tile.dataset.variantFormat);
      });

      // Belt-and-braces: the hero's own JS may flip aria-pressed without a
      // click event (e.g. when forcing Digital on a sold-out Print). Watch
      // for that and re-sync.
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var target = mutations[i].target;
          if (target.getAttribute('aria-pressed') === 'true' && target.dataset.variantFormat) {
            syncStrips(target.dataset.variantFormat);
            return;
          }
        }
      });
      var tiles = group.querySelectorAll('[data-variant-format]');
      for (var j = 0; j < tiles.length; j++) {
        observer.observe(tiles[j], { attributes: true, attributeFilter: ['aria-pressed'] });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theinmag-membership-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Flatten Judge.me's internal carousel wrappers in the store-mode list.
    // Judge.me's featured_carousel HTML has `.jdgm-carousel` / `.jdgm-carousel__items`
    // wrappers that apply flexbox + transforms to slide cards horizontally —
    // when we want a vertical stacked list, those wrappers shift the items
    // off-screen left. Solution: move every `.jdgm-carousel-item` to be a
    // direct child of `.theinmag-membership-reviews__list`, then drop the
    // intermediary containers entirely. After this the items are flat
    // siblings the CSS can stack vertically.
    // Map of candidate Judge.me class names per slot — we look up each
    // child by trying several known class names. Judge.me's featured_carousel
    // HTML has varied across versions; this is the canonical 2026 set with
    // legacy fallbacks.
    var SLOT_SELECTORS = {
      rating:    ['.jdgm-carousel-item__review-rating', '.jdgm-carousel-item__rating', '.jdgm-rev__rating'],
      name:      ['.jdgm-carousel-item__reviewer-name', '.jdgm-carousel-item__reviewer', '.jdgm-carousel-item__author', '.jdgm-rev__author'],
      timestamp: ['.jdgm-carousel-item__timestamp', '.jdgm-carousel-item__date', '.jdgm-carousel-item__time', '.jdgm-carousel-item__date-string', '.jdgm-carousel-item__published-at', '.jdgm-carousel-item__time-ago', '.jdgm-rev__timestamp', '.jdgm-rev__br-buyer', 'time'],
      title:     ['.jdgm-carousel-item__review-title', '.jdgm-carousel-item__title', '.jdgm-rev__title'],
      body:      ['.jdgm-carousel-item__review-body', '.jdgm-carousel-item__body', '.jdgm-carousel-item__content', '.jdgm-rev__body']
    };

    function findSlot(item, slot) {
      var sels = SLOT_SELECTORS[slot];
      for (var i = 0; i < sels.length; i++) {
        var el = item.querySelector(sels[i]);
        if (el) return el;
      }
      return null;
    }

    function reorderRow(item) {
      // Move each child slot to be a direct child of `item` in the desired
      // order. appendChild on an existing node MOVES it. Atari-style order:
      // stars → name → date → headline → body.
      ['rating', 'name', 'timestamp', 'title', 'body'].forEach(function (slot) {
        var el = findSlot(item, slot);
        if (el) item.appendChild(el);
      });
    }

    function flattenList(host) {
      var items = host.querySelectorAll('.jdgm-carousel-item');
      items.forEach(function (item) {
        if (item.parentNode !== host) {
          host.appendChild(item);
        }
        // Strip Judge.me's "review left on [product]" indicators.
        var productJunk = item.querySelectorAll('[class*="__product"], [class*="-spinner"], [class*="loading-spinner"]');
        productJunk.forEach(function (p) {
          if (p.parentNode) p.parentNode.removeChild(p);
        });
        reorderRow(item);
      });
      var cruft = host.querySelectorAll('.jdgm-carousel, .jdgm-carousel__items, .jdgm-carousel__item-container, .jdgm-carousel-title-and-link, .jdgm-carousel__arrow-left, .jdgm-carousel__arrow-right, .jdgm-carousel__arrows');
      cruft.forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });
    }

    function applyPagination(host, page) {
      var perPage = parseInt(host.dataset.perPage || '8', 10);
      var items = host.querySelectorAll('.jdgm-carousel-item');
      var totalPages = Math.max(1, Math.ceil(items.length / perPage));
      page = Math.max(1, Math.min(page, totalPages));
      host.dataset.currentPage = String(page);

      items.forEach(function (item, i) {
        var pageOfItem = Math.floor(i / perPage) + 1;
        item.classList.toggle('is-page-hidden', pageOfItem !== page);
      });

      buildPaginationNav(host, page, totalPages);

      // Scroll the section heading back into view when changing pages so the
      // user doesn't lose context mid-list.
      var section = host.closest('[data-theinmag-membership-reviews]');
      var heading = section && section.querySelector('#theinmag-membership-reviews-heading');
      if (heading && page !== 1) {
        var rect = heading.getBoundingClientRect();
        window.scrollTo({
          top: window.scrollY + rect.top - 96,
          behavior: 'smooth'
        });
      }
    }

    function buildPaginationNav(host, page, totalPages) {
      var section = host.closest('[data-theinmag-membership-reviews]') || host.parentNode;
      var nav = section.querySelector('[data-reviews-pagination]');
      if (!nav) return;
      nav.innerHTML = '';
      if (totalPages <= 1) { nav.hidden = true; return; }
      nav.hidden = false;

      function addArrow(direction, disabled, targetPage) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'theinmag-membership-reviews__page-arrow theinmag-membership-reviews__page-arrow--' + direction;
        btn.setAttribute('aria-label', direction === 'prev' ? 'Previous page' : 'Next page');
        btn.innerHTML = direction === 'prev' ? '‹' : '›';
        btn.disabled = disabled;
        btn.addEventListener('click', function () { applyPagination(host, targetPage); });
        nav.appendChild(btn);
      }
      function addPage(n) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'theinmag-membership-reviews__page';
        if (n === page) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'page');
        }
        btn.textContent = String(n);
        btn.setAttribute('aria-label', 'Page ' + n);
        btn.addEventListener('click', function () { applyPagination(host, n); });
        nav.appendChild(btn);
      }
      function addEllipsis() {
        var span = document.createElement('span');
        span.className = 'theinmag-membership-reviews__page-ellipsis';
        span.textContent = '…';
        span.setAttribute('aria-hidden', 'true');
        nav.appendChild(span);
      }

      addArrow('prev', page === 1, page - 1);

      // Compress middle pages when total > 6 (Atari-style: 1 2 3 4 … 27).
      if (totalPages <= 6) {
        for (var i = 1; i <= totalPages; i++) addPage(i);
      } else {
        addPage(1);
        if (page > 3) addEllipsis();
        var start = Math.max(2, page - 1);
        var end = Math.min(totalPages - 1, page + 1);
        for (var j = start; j <= end; j++) addPage(j);
        if (page < totalPages - 2) addEllipsis();
        addPage(totalPages);
      }

      addArrow('next', page === totalPages, page + 1);
    }

    function initLists() {
      document.querySelectorAll('.theinmag-membership-reviews__list').forEach(function (host) {
        flattenList(host);
        applyPagination(host, parseInt(host.dataset.currentPage || '1', 10));
      });
    }

    function init() {
      initLists();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Re-run after load in case Judge.me's JS rearranged things after our first pass.
    window.addEventListener('load', function () { setTimeout(init, 50); });

    // Expand/collapse mechanic for product-mode "Read all reviews" panel
    // (unchanged from prior version).
    document.querySelectorAll('[data-theinmag-membership-reviews]').forEach(function (root) {
      var trigger = root.querySelector('[data-expand-trigger]');
      var panel = root.querySelector('#theinmag-membership-reviews-full');
      var labelEl = root.querySelector('[data-expand-label-text]');
      if (!trigger || !panel || !labelEl) return;

      var expandLabel = root.dataset.expandLabel || 'Read all reviews';
      var collapseLabel = root.dataset.collapseLabel || 'Hide all reviews';

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.maxHeight = '0px'; });
          panel.addEventListener('transitionend', function handler() {
            panel.setAttribute('hidden', '');
            panel.style.maxHeight = '';
            panel.removeEventListener('transitionend', handler);
          });
          trigger.setAttribute('aria-expanded', 'false');
          labelEl.textContent = expandLabel;
        } else {
          panel.removeAttribute('hidden');
          panel.style.maxHeight = '0px';
          requestAnimationFrame(function () {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
          panel.addEventListener('transitionend', function handler() {
            panel.style.maxHeight = 'none';
            panel.removeEventListener('transitionend', handler);
          });
          trigger.setAttribute('aria-expanded', 'true');
          labelEl.textContent = collapseLabel;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theinmag-stack-module"] && !Shopify.designMode) return;
  try {
    
  /* Click tracking for the Digital Stack push (2026-08-12, feeds Ryan's
     which-surface-sells question and any future A/B). Sends a GA4 custom
     event via the real gtag that has run on-page since the 07 Aug tag
     swap. Guarded: analytics must never break a click, and if gtag is
     absent (blocked or removed) this is a silent no-op. */
  document.addEventListener('click', function (event) {
    var cta = event.target.closest('[data-stack-cta]');
    if (!cta) return;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'stack_cta_click', {
          stack_mode: cta.getAttribute('data-stack-cta'),
          page_path: window.location.pathname
        });
      }
    } catch (err) { /* never block the navigation */ }
  });

  /* Fresh kid character per page load (Ryan, 2026-08-12): re-roll from
     the emitted candidate pool so even a cached page varies per visit. */
  (function () {
    var chars = document.querySelectorAll('[data-stack-char-pool]');
    for (var i = 0; i < chars.length; i++) {
      var pool = (chars[i].getAttribute('data-stack-char-pool') || '').split('|');
      if (pool.length > 1) {
        chars[i].src = pool[Math.floor(Math.random() * pool.length)];
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theinmag-stockists-hero"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-theinmag-stockists]');
    if (!section) return;

    var dataNode = section.querySelector('[data-stockists-data]');
    var listNode = section.querySelector('[data-stockists-list]');
    var emptyNode = section.querySelector('[data-stockists-empty]');
    var stateFilter = section.querySelector('[data-stockists-state-filter]');
    var searchInput = section.querySelector('[data-stockists-search]');
    var mapEl = section.querySelector('[data-stockists-map]');
    var radiusInfoNode = section.querySelector('[data-stockists-radius-info]');

    var map = null;
    var markerByStockistId = {};
    var radiusOverlay = null;
    var AU_BOUNDS = [[-44.0, 113.0], [-10.0, 154.0]];
    var RADIUS_KM = 80;
    var geocodeCache = {};
    var searchDebounce = null;

    // Sync the panel height to the actual rendered top header (announcement
    // bar + main header). Without this the panel uses calc(100vh - 80px)
    // which doesn't account for the announcement bar — CTA gets clipped.
    // Query every section in the header group rather than naming them by
    // class — section classes are theme-author-controlled (see schema)
    // and brittle. The group class is set by Shopify and stable.
    function syncHeaderHeight() {
      var groupSections = document.querySelectorAll('.shopify-section-group-header-group');
      var h = 0;
      groupSections.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) h += r.height;
      });
      if (h > 0) section.style.setProperty('--st-header-h', h + 'px');
    }
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);
    window.addEventListener('load', syncHeaderHeight);
    setTimeout(syncHeaderHeight, 250);

    var stockists = [];
    if (dataNode) {
      try { stockists = JSON.parse(dataNode.textContent || '[]'); }
      catch (e) { console.warn('[stockists] data parse failed', e); }
    }

    // SVG icon factory - kept inline so we don't ship a separate sprite
    // for three icons. Returns an HTML string (safe - no user input).
    function icon(name) {
      switch (name) {
        case 'instagram':
          return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="5" ry="5"></rect><path d="M16 11.4a4 4 0 1 1-7.9 1.2 4 4 0 0 1 7.9-1.2z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>';
        case 'globe':
          return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><line x1="3" y1="12" x2="21" y2="12"></line><path d="M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18z"></path></svg>';
        case 'phone':
          return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.6a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z"></path></svg>';
        case 'maps-arrow':
          return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="12" height="12"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="13 6 19 12 13 18"></polyline></svg>';
      }
      return '';
    }

    // Phone link uses tel: with non-digit chars stripped (Aussie numbers
    // tend to render with spaces). We keep the human label readable.
    function telHref(raw) {
      return 'tel:' + (raw || '').replace(/[^0-9+]/g, '');
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function typeLabel(t) {
      switch (t) {
        case 'gift_shop': return 'Gift shop';
        case 'newsagent': return 'Newsagent';
        case 'bookshop':  return 'Bookshop';
        case 'gallery':   return 'Gallery';
        case 'cafe':      return 'Cafe';
        default:          return 'Other';
      }
    }

    function renderCard(s) {
      var addressLine1 = escapeHtml(s.street_address || '');
      var addressLine2 = [s.suburb, s.state, s.postcode].filter(Boolean).map(escapeHtml).join(' ');
      var contactLine = s.contact_name
        ? '<p class="theinmag-stockists__card-contact">Contact ' + escapeHtml(s.contact_name) + '</p>'
        : '';

      var icons = '';
      if (s.instagram_handle) {
        icons += '<a class="theinmag-stockists__card-icon" href="https://instagram.com/' + encodeURIComponent(s.instagram_handle) + '" target="_blank" rel="noopener noreferrer" aria-label="' + escapeHtml(s.shop_name) + ' on Instagram">' + icon('instagram') + '</a>';
      }
      if (s.website_url) {
        icons += '<a class="theinmag-stockists__card-icon" href="' + escapeHtml(s.website_url) + '" target="_blank" rel="noopener noreferrer" aria-label="' + escapeHtml(s.shop_name) + ' website">' + icon('globe') + '</a>';
      }
      if (s.contact_phone) {
        icons += '<a class="theinmag-stockists__card-icon" href="' + escapeHtml(telHref(s.contact_phone)) + '" aria-label="Call ' + escapeHtml(s.shop_name) + '">' + icon('phone') + '</a>';
      }

      // Query by shop name + address (not raw coords) so Google shows the
      // named place / business rather than just a dropped pin on coordinates.
      var mapsQuery = [s.shop_name, s.street_address, s.suburb, s.state, s.postcode]
        .filter(Boolean).join(', ');
      var mapsHref = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(mapsQuery);

      return (
        '<li class="theinmag-stockists__card" data-stockist-id="' + escapeHtml(s.id) + '" data-type="' + escapeHtml(s.type) + '" data-state="' + escapeHtml(s.state) + '" tabindex="0">' +
          '<div class="theinmag-stockists__card-body">' +
            '<h3 class="theinmag-stockists__card-name">' + escapeHtml(s.shop_name) + '</h3>' +
            '<span class="theinmag-stockists__card-chip">' + escapeHtml(typeLabel(s.type)) + '</span>' +
            '<p class="theinmag-stockists__card-address">' + addressLine1 + (addressLine2 ? '<br>' + addressLine2 : '') + '</p>' +
            contactLine +
            '<a class="theinmag-stockists__card-maps" href="' + mapsHref + '" target="_blank" rel="noopener noreferrer">Open in Google Maps ' + icon('maps-arrow') + '</a>' +
          '</div>' +
          '<div class="theinmag-stockists__card-icons">' + icons + '</div>' +
        '</li>'
      );
    }

    function render(list) {
      if (!listNode) return;
      if (!list.length) {
        listNode.innerHTML = '';
        if (emptyNode) emptyNode.hidden = false;
        return;
      }
      if (emptyNode) emptyNode.hidden = true;
      listNode.innerHTML = list.map(renderCard).join('');
    }

    function sortAlpha(a, b) {
      return a.shop_name.localeCompare(b.shop_name);
    }

    // Great-circle distance between two lat/lng points, kilometres.
    function haversineKm(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var dLat = (lat2 - lat1) * Math.PI / 180;
      var dLng = (lng2 - lng1) * Math.PI / 180;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
            + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180)
            * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
    }

    // Geocode any Australian-anchored query (postcode, suburb, town) to
    // lat/lng + a short display label via Nominatim (OpenStreetMap).
    // Cached in memory so repeat searches are instant. Falls back to
    // null on failure — caller treats null as "fall back to text
    // contains-match".
    function geocodeQuery(q) {
      var key = q.toLowerCase().trim();
      if (geocodeCache[key] !== undefined) return Promise.resolve(geocodeCache[key]);
      // countrycodes=au is the documented Nominatim way to constrain by
      // country (ISO 3166-1 alpha-2). The country=Australia param turns
      // out to be unreliable — returns empty for "bendigo" alone.
      var url = 'https://nominatim.openstreetmap.org/search?countrycodes=au&q='
              + encodeURIComponent(q) + '&format=json&limit=1';
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (arr) {
          if (!arr || !arr[0]) { geocodeCache[key] = null; return null; }
          var first = arr[0];
          var label = String(first.display_name || '').split(',')[0].trim() || q;
          var result = {
            center: { lat: parseFloat(first.lat), lng: parseFloat(first.lon) },
            label: label,
          };
          geocodeCache[key] = result;
          return result;
        })
        .catch(function () { geocodeCache[key] = null; return null; });
    }

    function clearRadiusOverlay() {
      if (radiusOverlay && map) { map.removeLayer(radiusOverlay); }
      radiusOverlay = null;
    }
    function drawRadiusOverlay(center, radiusKm) {
      if (!map || !window.L) return;
      clearRadiusOverlay();
      radiusOverlay = L.circle([center.lat, center.lng], {
        radius: radiusKm * 1000,
        color: '#5D3A7A',
        weight: 1.5,
        dashArray: '4 4',
        fillColor: '#E8DEEF',
        fillOpacity: 0.15,
        interactive: false,
      }).addTo(map);
    }

    function setRadiusInfo(text) {
      if (!radiusInfoNode) return;
      if (text) {
        radiusInfoNode.textContent = text;
        radiusInfoNode.hidden = false;
      } else {
        radiusInfoNode.textContent = '';
        radiusInfoNode.hidden = true;
      }
    }

    // Routing: any query of 3+ characters tries Nominatim geocode first
    // (works for postcodes AND town/suburb names — the input placeholder
    // promises both). On a hit we radius-search 80 km from the geocoded
    // point, sorted by distance ascending. On a miss we fall back to a
    // text contains-match against shop name / suburb / postcode. Empty
    // and very short queries (1-2 chars) skip geocoding to avoid noisy
    // matches and keep us under Nominatim's 1-req/sec policy.
    function applyFilters() {
      var st = stateFilter ? stateFilter.value : 'all';
      var q = (searchInput && searchInput.value || '').trim();

      if (q.length >= 3) {
        geocodeQuery(q).then(function (geo) {
          if (geo && geo.center) {
            applyRadiusFilter(st, geo.center, RADIUS_KM, geo.label || q);
          } else {
            applyTextFilter(st, q.toLowerCase());
          }
        });
        return;
      }

      applyTextFilter(st, q.toLowerCase());
    }

    function applyTextFilter(st, qLower) {
      clearRadiusOverlay();
      setRadiusInfo('');
      var filtered = stockists.filter(function (s) {
        if (st !== 'all' && s.state !== st) return false;
        if (qLower) {
          var hay = (s.shop_name + ' ' + s.suburb + ' ' + s.postcode).toLowerCase();
          if (hay.indexOf(qLower) === -1) return false;
        }
        return true;
      });
      filtered.sort(sortAlpha);
      render(filtered);
      renderMarkers(filtered);
    }

    function applyRadiusFilter(st, center, radiusKm, label) {
      drawRadiusOverlay(center, radiusKm);
      var withDist = stockists
        .filter(function (s) { return st === 'all' || s.state === st; })
        .map(function (s) {
          var lat = parseFloat(s.latitude), lng = parseFloat(s.longitude);
          if (!isFinite(lat) || !isFinite(lng)) return null;
          return { s: s, d: haversineKm(center.lat, center.lng, lat, lng) };
        })
        .filter(function (x) { return x && x.d <= radiusKm; })
        .sort(function (a, b) { return a.d - b.d; });
      var filtered = withDist.map(function (x) { return x.s; });
      var n = filtered.length;
      var msg = n === 0
        ? 'No stockists within ' + radiusKm + ' km of ' + label + '.'
        : 'Showing ' + n + ' stockist' + (n === 1 ? '' : 's') + ' within ' + radiusKm + ' km of ' + label + '.';
      setRadiusInfo(msg);
      render(filtered);
      // In radius mode we suppress renderMarkers' own auto-fly and frame
      // the map to the full radius circle instead — that way the user
      // sees the search-area scale, not just the matched markers.
      renderMarkers(filtered, { skipFly: true });
      if (map && radiusOverlay) {
        map.flyToBounds(radiusOverlay.getBounds(), { padding: [30, 30], duration: 0.6 });
      }
    }

    // ===== Leaflet map =====

    // Wait for the deferred /assets/leaflet.js to expose window.L. Polling
    // beats DOMContentLoaded here because Dawn concatenates section JS into
    // a bundle whose execution order vs. <script defer> tags is brittle.
    function ensureLeaflet(cb) {
      if (window.L) { cb(); return; }
      var n = 0, max = 100; // 5s at 50ms
      var t = setInterval(function () {
        if (window.L) { clearInterval(t); cb(); return; }
        if (++n > max) { clearInterval(t); console.warn('[stockists] Leaflet failed to load'); }
      }, 50);
    }

    function buildMarkerIcon(type) {
      return L.divIcon({
        className: '',
        html: '<div class="theinmag-stockists__marker" data-type="' + escapeHtml(type) + '"></div>',
        iconSize: [28, 28],
        iconAnchor: [14, 14],
        popupAnchor: [0, -14],
      });
    }

    function popupHtml(s) {
      var line2 = [s.suburb, s.state, s.postcode].filter(Boolean).map(escapeHtml).join(' ');
      var lines = [escapeHtml(s.street_address || ''), line2].filter(Boolean);
      return (
        '<span class="theinmag-popup__name">' + escapeHtml(s.shop_name) + '</span>' +
        '<span class="theinmag-popup__addr">' + lines.join('<br>') + '</span>'
      );
    }

    function initMap() {
      if (map || !mapEl) return;
      map = L.map(mapEl, {
        zoomControl: true,
        scrollWheelZoom: true,
        attributionControl: true,
      }).fitBounds(AU_BOUNDS);
      // Basemap: OpenStreetMap standard tiles. Keyless and reliable. We were
      // on Carto Voyager, but Carto now requires an API key on
      // basemaps.cartocdn.com and the tiles fell back to "API KEY REQUIRED"
      // watermarks (found 2026-09-15). OSM needs no key; note it has no {r}
      // retina variant and its subdomains are a/b/c. If a cleaner style is
      // wanted later, add a Carto or MapTiler key and swap this one line back.
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        subdomains: 'abc',
        maxZoom: 19,
      }).addTo(map);
    }

    function clearMarkers() {
      Object.keys(markerByStockistId).forEach(function (id) {
        var m = markerByStockistId[id];
        if (m && map) map.removeLayer(m);
        delete markerByStockistId[id];
      });
    }

    function renderMarkers(list, opts) {
      if (!map) return; // first call may run before Leaflet is ready
      opts = opts || {};
      clearMarkers();
      var bounds = [];
      list.forEach(function (s) {
        var lat = parseFloat(s.latitude);
        var lng = parseFloat(s.longitude);
        if (!isFinite(lat) || !isFinite(lng)) return;
        var m = L.marker([lat, lng], { icon: buildMarkerIcon(s.type) }).addTo(map);
        m.bindPopup(popupHtml(s));
        m.on('click', function () { activateStockist(s.id, { fromMap: true }); });
        markerByStockistId[s.id] = m;
        bounds.push([lat, lng]);
      });
      if (opts.skipFly) return;
      if (!bounds.length) return; // filter cleared everything; keep prior view
      if (bounds.length === 1) {
        map.flyTo(bounds[0], Math.max(map.getZoom(), 9), { duration: 0.6 });
      } else {
        map.flyToBounds(bounds, { padding: [40, 40], maxZoom: 12, duration: 0.6 });
      }
    }

    function activateStockist(id, opts) {
      opts = opts || {};
      // Highlight card
      if (listNode) {
        var cards = listNode.querySelectorAll('.theinmag-stockists__card');
        cards.forEach(function (c) {
          c.classList.toggle('is-active', c.getAttribute('data-stockist-id') === id);
        });
        var activeCard = listNode.querySelector('[data-stockist-id="' + id + '"]');
        if (activeCard && !opts.fromCard) {
          activeCard.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
      // Highlight marker dot
      Object.keys(markerByStockistId).forEach(function (mid) {
        var m = markerByStockistId[mid];
        var iconEl = m && m.getElement && m.getElement();
        var dot = iconEl && iconEl.querySelector('.theinmag-stockists__marker');
        if (dot) dot.classList.toggle('is-active', mid === id);
      });
      // From-card click flies + opens popup; from-map click only highlights
      // (popup opens via Leaflet's own click handler).
      if (opts.fromCard) {
        var marker = markerByStockistId[id];
        if (marker && map) {
          map.flyTo(marker.getLatLng(), Math.max(map.getZoom(), 9), { duration: 0.6 });
          marker.openPopup();
        }
      }
    }

    // Card click → activate (skip inner link/button clicks so Maps/IG/etc.
    // still work)
    if (listNode) {
      listNode.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        var card = e.target.closest('.theinmag-stockists__card');
        if (!card) return;
        var id = card.getAttribute('data-stockist-id');
        if (id) activateStockist(id, { fromCard: true });
      });
    }

    if (stateFilter) stateFilter.addEventListener('change', applyFilters);
    if (searchInput) searchInput.addEventListener('input', function () {
      // Debounce to keep us under Nominatim's 1-req/sec policy when the
      // user types a postcode digit-by-digit, and to avoid jittery UI on
      // text searches.
      clearTimeout(searchDebounce);
      searchDebounce = setTimeout(applyFilters, 300);
    });

    applyFilters();

    ensureLeaflet(function () {
      initMap();
      applyFilters(); // re-run so renderMarkers paints onto the now-ready map

      // The map can sit far below the fold (e.g. the /pages/instock stockist
      // hub), where it may initialise before its container has settled, so the
      // markers never paint. Re-measure + re-paint once it scrolls into view,
      // and on resize. Harmless on /pages/stockists where it's already visible.
      if (map && mapEl) {
        var refitMap = function () {
          map.invalidateSize();
          applyFilters();
        };
        setTimeout(refitMap, 300);

        // Scale the dots with zoom: small when zoomed out over all of
        // Australia, full size when zoomed into a town. Sets a CSS var the
        // marker CSS reads (scale 0.55 at zoom <=5, ramping to 1 at zoom 9+).
        var updateMarkerScale = function () {
          var z = map.getZoom();
          var scale = z <= 5 ? 0.55 : (z >= 9 ? 1 : 0.55 + (z - 5) * 0.1125);
          mapEl.style.setProperty('--st-marker-scale', scale.toFixed(2));
        };
        map.on('zoom', updateMarkerScale);
        updateMarkerScale();

        if ('IntersectionObserver' in window) {
          var mapIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { refitMap(); mapIO.disconnect(); }
            });
          }, { threshold: 0.01 });
          mapIO.observe(mapEl);
        }
        window.addEventListener('resize', function () { map.invalidateSize(); });
      }
    });

    // (The "Become a stockist" CTA is a plain <a href> to
    // /pages/become-a-stockist now — no JS needed. The sibling
    // theinmag-stockists-modal section is no longer used by this page
    // but its file remains for any future modal-style use.)
  })();

  } catch(e) { console.error(e); }
})();
})();
